export default "__VITE_ASSET__b27af6de__"